<template>
  <ui-menu-base-trigger @focus="handleFocus">
    <template #default="{ openMenu }">
      <button
        ref="buttonRef"
        type="button"
        class="flex grow items-center gap-2 rounded border px-3 py-2 transition-colors"
        :data-testid
        :class="[
          active &&
            'border-button-primary-outline hover:border-button-primary-outline shadow-[0_0_4_0_rgba(59,76,191,0.6)]',
          !active && !disabled && 'border-gray-30 hover:border-gray-40',
          small && 'h-8 text-xs',
          !small && 'h-10 text-sm',
          disabled && 'bg-gray-20 border-gray-20 pointer-events-none cursor-not-allowed',
          !disabled && 'bg-gray-10',
          textClass,
        ]"
        @click="openMenu"
        @keydown.enter="openMenu"
      >
        <div class="flex grow items-center gap-2 leading-none">
          <slot name="icon" />
          <slot />
        </div>
        <double-caret-icon class="icon-m" :class="[disabled && 'text-gray-50', !disabled && 'text-gray-60']" />
      </button>
    </template>
  </ui-menu-base-trigger>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import DoubleCaretIcon from '../../UiDropdownV2/assets/double-caret.svg'
import UiMenuBaseTrigger from './UiMenuBaseTrigger.vue'

const props = defineProps<{
  active?: boolean
  small?: boolean
  disabled?: boolean
  placeholder?: boolean
  dataTestid?: string
}>()

const buttonRef = ref<HTMLButtonElement | null>(null)

const textClass = computed(() => {
  if (props.disabled) return 'text-gray-60'
  if (props.placeholder) return 'text-gray-50'
  return 'text-gray-90'
})

const handleFocus = () => {
  buttonRef.value?.focus()
}
</script>
